window.waitForElem =
	window.waitForElem ||
	((waitFor, callback, minElements = 1, variable = false) => {
		function checkElements() {
			if (variable) {
				return waitFor;
			} else {
				return window.document.querySelectorAll(waitFor);
			}
		}

		var thisElem = checkElements(),
			timeOut;
		if ((!variable && thisElem.length >= minElements) || (variable && typeof thisElem !== "undefined")) {
			return callback(thisElem);
		} else {
			var interval = setInterval(function () {
				thisElem = checkElements();
				if ((!variable && thisElem.length >= minElements) || (variable && typeof thisElem !== "undefined")) {
					clearInterval(interval);
					clearTimeout(timeOut);
					return callback(thisElem);
				}
			}, 200);
			timeOut = setTimeout(function () {
				// Fallback
				clearInterval(interval);
				return callback(false);
			}, 500000);
		}
	});

waitForElem(".currency-selector-toggler", (element) => {
	if (element) {
		let currencySelectorToggler = document.querySelectorAll(".currency-selector-toggler");
		currencySelectorToggler.forEach((e) => {
			e.addEventListener("click", function () {
				if (document.querySelector(".md-app-embed")) {
					document.querySelector(".md-app-embed").style.display = "block";
				}
			});
		});
	}
});

waitForElem(".close-currency-selector", (element) => {
	if (element) {
		document.querySelector(".close-currency-selector").addEventListener("click", function () {
			var searchDrawer = document.querySelector("#NavDrawerSearch");
			if (searchDrawer && searchDrawer.classList.contains("drawer--is-open")) {
				searchDrawer.classList.add("is-transitioning");
				searchDrawer.classList.remove("drawer--is-open");
				window.setTimeout(function () {
					searchDrawer.classList.remove("is-transitioning");
				}, 500);
			}

			if (document.querySelector(".np-currency-selector")) {
				document.querySelector(".np-currency-selector").style.display = "none";
			}
			if (document.querySelector("#CurrencyList-footer")) {
				document.querySelector("#CurrencyList-footer").style.display = "none";
			}
			document.querySelector("body").classList.remove("overflow--none");
		});
	}
});

waitForElem(".cb-cookie_consent-container-text_container", (element) => {
	if (element) {
		document.querySelector(".cb-cookie_consent-container-text_container").innerHTML =
			"This website uses cookies to provide an optimised shopping experience. By using the site you agree to the use of cookies. For more information, visit our <span class='cp-show-button'>Cookie Policy</span> and <span class='pp-show-button'>Privacy Policy</span> pages.";

		document.querySelector(".cp-show-button").addEventListener("click", () => {
			document.querySelector('[data-id="cookies"]').click();
		});

		document.querySelector(".pp-show-button").addEventListener("click", () => {
			document.querySelector('[data-id="privacy-security"]').click();
		});
	}
});

const expirationDate = new Date();
expirationDate.setDate(expirationDate.getDate() + 7);
//document.cookie = `mdApp_cookieModalTime=true; expires=${expirationDate.toUTCString()}; path=/`;

waitForElem(".rbr-page-container, [id*=rbr-bundle]", (element) => {
	if (element) {
		document.querySelector(".multibuy-promotion-banner").style.display = "block";
	}
});

